import { useEffect, useRef, useState } from 'react';

const GAP_PX = 24;

export function MarqueeText({ text, className = '', title = '' }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);
  const [distance, setDistance] = useState(0);
  const value = String(text || '');

  useEffect(() => {
    const measure = () => {
      const containerWidth = containerRef.current?.clientWidth || 0;
      const textWidth = textRef.current?.scrollWidth || 0;
      const shouldMove = textWidth > containerWidth + 1;
      setOverflowing(shouldMove);
      setDistance(shouldMove ? textWidth + GAP_PX : 0);
    };

    measure();
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(measure) : null;
    if (observer && containerRef.current) observer.observe(containerRef.current);
    if (observer && textRef.current) observer.observe(textRef.current);
    window.addEventListener('resize', measure);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [value]);

  const duration = Math.max(7, distance / 22);

  return (
    <span ref={containerRef} className={`shared-marquee ${overflowing ? 'is-overflowing' : ''} ${className}`.trim()} title={title || value}>
      <span
        className="shared-marquee-track"
        style={overflowing ? { '--marquee-distance': `${distance}px`, '--marquee-duration': `${duration}s` } : undefined}
      >
        <span ref={textRef} className="shared-marquee-copy">{value}</span>
        {overflowing ? <span className="shared-marquee-copy" aria-hidden="true">{value}</span> : null}
      </span>
    </span>
  );
}
